__webpack_require__.p = "/sales-dashboard/";